import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ASSETS_PATH } from 'src/app/core/config';
import { JudgeForm } from 'src/app/core/models/judgeForm.model';
import { UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { JudgeFormService } from 'src/app/core/services/judgeForm.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'app-judge-form',
  templateUrl: './judge-form.component.html',
  styleUrls: ['./judge-form.component.scss']
})
export class JudgeFormComponent implements OnInit {
  userBasicInfo = new UserBasicInfo();
  judgeForm = new JudgeForm();
  createJudgeForm: FormGroup;
  assetsPath = ASSETS_PATH;
  isImage = false;
  isFilled = false;
  isUpdated = false;
  selectedEvents = [];
  selectedLanguages = [];
  eventSelection = {
    firstEvent: false,
    secondEvent: false,
    thirdEvent: false,
    fourthEvent: false,
    fifthEvent: false,
    sixthEvent: false
  }
  languageSelection = {
    ev3: false,
    scratch: false,
    python: false,
  }
  responseEvent: string[]
  responseLanguage: string[]

  constructor(private alertService: AlertService,
    private judgeFormService: JudgeFormService,
    private userService: UserService,
    private loadingService: LoadingService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.createJudgeForm = this.formBuilder.group({
      isConflict: new FormControl('', [
        Validators.required
      ]),
      isVolunteeredBefore: new FormControl('', [
        Validators.required
      ]),
      volunteerExperience: new FormControl('', [
        Validators.maxLength(1000)
      ]),
      isJudgedBefore: new FormControl('', [
        Validators.required
      ]),
      judgedTournaments: new FormControl('', [
        Validators.maxLength(250)
      ]),
      isProgramming: new FormControl('', [
        Validators.required
      ]),
      programmingLanguages: new FormControl('', [
        Validators.maxLength(250)
      ]),
      judgeExplanation: new FormControl('', [
        Validators.required,
        Validators.maxLength(1000)
      ]),
      reference: new FormControl('', [
        Validators.maxLength(250)
      ]),
      additionalThoughts: new FormControl('', [
        Validators.maxLength(1000)
      ]),
    });
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
    this.getForm();
  }

  getForm() {
    this.selectedEvents = [];
    this.selectedLanguages = [];
    this.loadingService.setLoading(true);
    this.judgeFormService.getMyJudgeForm().subscribe(response => {
      if (response.success) {
        this.isFilled = response.isFilledBefore;
        this.isUpdated = response.isUpdated;
        if (this.isFilled) {
          this.createJudgeForm.controls['isConflict'].setValue(response.isConflict ? "yes" : "no");
          this.createJudgeForm.controls['isVolunteeredBefore'].setValue(response.isVolunteeredBefore ? "yes" : "no");
          this.createJudgeForm.controls['volunteerExperience'].setValue(response.volunteerExperience);
          this.createJudgeForm.controls['isJudgedBefore'].setValue(response.isJudgedBefore ? "yes" : "no");
          this.createJudgeForm.controls['judgedTournaments'].setValue(response.judgedTournaments);
          this.createJudgeForm.controls['isProgramming'].setValue(response.isProgramming ? "yes" : "no");
          this.createJudgeForm.controls['judgeExplanation'].setValue(response.judgeExplanation);
          this.createJudgeForm.controls['reference'].setValue(response.reference);
          this.createJudgeForm.controls['additionalThoughts'].setValue(response.additionalThoughts);
          this.responseEvent = response.judgedTournaments.split(", ", 5);
          this.responseLanguage = response.programmingLanguages.split(", ", 3);
          this.setInitialEventSelection();
          this.setInitialLanguageSelection();
        }
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  setInitialEventSelection(){
    for (var val of this.responseEvent) {
      if (val == "2018 - 2019 INTO ORBIT: Uzay Serüveni") {
        this.eventSelection.firstEvent = true;
      }
      if (val == "2019 - 2020 CITY SHAPER: Şehri Şekillendir") {
        this.eventSelection.secondEvent = true;
      }
      if (val == "2020 - 2021 RePLAY") {
        this.eventSelection.thirdEvent = true;
      }
      if (val == "2021 - 2022 Cargo Connect") {
        this.eventSelection.fourthEvent = true;
      }
      if (val == "2022 - 2023 Superpowered") {
        this.eventSelection.fifthEvent = true;
      }
      if (val == "2023 - 2024 Masterpiece") {
        this.eventSelection.sixthEvent = true;
      }
      this.selectedEvents.push(val);
    }
  }

  setInitialLanguageSelection(){
    for (var val of this.responseLanguage) {
      if (val == "EV3") {
        this.languageSelection.ev3 = true;
      }
      if (val == "Scratch") {
        this.languageSelection.scratch = true;
      }
      if (val == "Python") {
        this.languageSelection.python = true;
      }
      this.selectedLanguages.push(val);
    }
  }

  save() {
    if (this.createJudgeForm.invalid) {
      this.alertService.alert('Hata', 'Lütfen formdaki alanları eksiksiz tamamlayınız!', 'error')
      return;
    }
    if (this.createJudgeForm.valid) {
      this.loadingService.setLoading(true);
      let data = Object.assign({}, this.createJudgeForm.value);

      this.judgeForm.isConflict = data.isConflict == "yes";
      this.judgeForm.isVolunteeredBefore = data.isVolunteeredBefore == "yes";
      this.judgeForm.volunteerExperience = data.volunteerExperience;
      this.judgeForm.isJudgedBefore = data.isJudgedBefore == "yes";
      this.judgeForm.judgedTournaments = "";
      // TODO: append events to selected events
      if (this.selectedEvents.length != 0) {
        this.judgeForm.judgedTournaments = this.selectedEvents.join(", ");
      }
      this.judgeForm.isProgramming = data.isProgramming == "yes";
      this.judgeForm.programmingLanguages = "";
      // TODO: append languages to the selected languages
      if (this.selectedLanguages.length != 0) {
        this.judgeForm.programmingLanguages = this.selectedLanguages.join(", ");
      }
      this.judgeForm.judgeExplanation = data.judgeExplanation;
      this.judgeForm.reference = data.reference;
      this.judgeForm.additionalThoughts = data.additionalThoughts;

      if (this.isFilled) {
        this.judgeFormService.updateJudgeForm(this.judgeForm).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Jüri başvuru formunuz güncellendi!', 'success');
            this.getForm();
            this.router.navigate(['/judge-form']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      } else {
        this.judgeFormService.createJudgeForm(this.judgeForm).subscribe(response => {
          if (response.success) {
            this.alertService.alert('Başarılı!', 'Jüri başvuru formunuz kaydedildi!', 'success');
            this.getForm();
            this.router.navigate(['/judge-form']);
          }
          this.loadingService.setLoading(false);
        }, (error) => {
          this.loadingService.setLoading(false);
          this.alertService.alert('Hata!', error.error.Message, 'error');
        })
      }
    }
  }

  get f() {
    return this.createJudgeForm.controls;
  }

  onEventChange(id:string, isChecked: boolean) {
    switch (id) 
    {
      case "2018 - 2019 INTO ORBIT: Uzay Serüveni":
        this.eventSelection.firstEvent = false
        if (isChecked) {
          this.eventSelection.firstEvent = true
        }
        break;
      case "2019 - 2020 CITY SHAPER: Şehri Şekillendir":
        this.eventSelection.secondEvent = false
        if (isChecked) {
          this.eventSelection.secondEvent = true
        }
        break;
      case "2020 - 2021 RePLAY":
        this.eventSelection.thirdEvent = false
        if (isChecked) {
          this.eventSelection.thirdEvent = true
        }
        break;
      case "2021 - 2022 Cargo Connect":
        this.eventSelection.fourthEvent = false
        if (isChecked) {
          this.eventSelection.fourthEvent = true
        }
        break;
      case "2022 - 2023 Superpowered":
        this.eventSelection.fifthEvent = false
        if (isChecked) {
          this.eventSelection.fifthEvent = true
        }
        break;
      case "2023 - 2024 Masterpiece":
        this.eventSelection.sixthEvent = false
        if (isChecked) {
          this.eventSelection.sixthEvent = true
        }
        break;    
    }
    if(isChecked) {
      this.selectedEvents.push(id);
    } else {
      let index = this.selectedEvents.indexOf(id);
      this.selectedEvents.splice(index,1);
    }
  }

  onLanguageChange(id:string, isChecked: boolean) {
    switch (id) 
    {
      case "EV3":
        this.languageSelection.ev3 = false
        if (isChecked) {
          this.languageSelection.ev3 = true
        }
        break;
      case "Scratch":
        this.languageSelection.scratch = false
        if (isChecked) {
          this.languageSelection.scratch = true
        }
        break;
      case "Python":
        this.languageSelection.python = false
        if (isChecked) {
          this.languageSelection.python = true
        }
        break;  
    }
    if(isChecked) {
      this.selectedLanguages.push(id);
    } else {
      let index = this.selectedLanguages.indexOf(id);
      this.selectedLanguages.splice(index,1);
    }
  }

}
